export default __webpack_public_path__ + "static/media/about-5.321e6016.png";